<template>
  <div>
    <v-row dense>
      <v-col cols="12">
        <v-subheader class="grey lighten-4 text--primary">
          <v-icon left>mdi-map-marker</v-icon>
          Endereço internacional
        </v-subheader>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="6">
        <v-text-field
          dense
          outlined
          hide-details
          label="Rua"
          class="required rounded-tag-small"
          :error="$v.endereco.rua.$error"
          @blur="$v.endereco.rua.$touch()"
          v-model="endereco.rua"
        />
      </v-col>
      <v-col cols="12" sm="3">
        <v-text-field
          dense
          outlined
          hide-details
          label="Número"
          class="rounded-tag-small"
          v-model="endereco.numero"
        />
      </v-col>
      <v-col cols="12" sm="3">
        <v-text-field
          dense
          outlined
          hide-details
          label="Bairro"
          class="rounded-tag-small"
          v-model="endereco.bairro"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="3">
        <v-text-field
          dense
          outlined
          hide-details
          label="Cidade"
          class="required rounded-tag-small"
          :error="$v.endereco.cidade.$error"
          @blur="$v.endereco.cidade.$touch()"
          v-model="endereco.cidade"
        />
      </v-col>
      <v-col cols="12" sm="3">
        <v-text-field
          dense
          outlined
          hide-details
          label="Estado/Província"
          class="required rounded-tag-small"
          :error="$v.endereco.provincia.$error"
          @blur="$v.endereco.provincia.$touch()"
          v-model="endereco.provincia"
        />
      </v-col>
      <v-col cols="12" sm="3">
        <v-text-field
          dense
          outlined
          hide-details
          label="Código Postal"
          class="required rounded-tag-small"
          :error="$v.endereco.codigoPostal.$error"
          @blur="$v.endereco.codigoPostal.$touch()"
          v-model="endereco.codigoPostal"
        />
      </v-col>
      <v-col cols="12" sm="3">
        <px-autocomplete-pais
          dense
          outlined
          hide-details
          label="País"
          class="required rounded-tag-small"
          :error="$v.endereco.pais.$error"
          @blur="$v.endereco.pais.$touch()"
          v-model="endereco.pais"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';

export default {
  mixins: [validationMixin],
  props: {
    endereco: {
      type: Object,
      required: true,
      default: () => ({
        rua: null,
        numero: null,
        bairro: null,
        cidade: null,
        provincia: null,
        codigoPostal: null,
        pais: null,
      }),
    },
  },
  validations: {
    endereco: {
      rua: {
        required,
      },
      cidade: {
        required,
      },
      provincia: {
        required,
      },
      codigoPostal: {
        required,
      },
      pais: {
        required,
      },
    },
  },
};
</script>
